module.exports = __webpack_public_path__ + "videos/mobile_en.411dff9.mp4";